module.exports = __webpack_public_path__ + "static/media/connected.01231e5f.svg";